import getStore from 'services/getStore';
import { setCurrentInteractionAction } from "actions/setCurrentInteractionAction";

export default (id, updateFocusedNodeId = false) => {
  getStore().dispatch(setCurrentInteractionAction(id, updateFocusedNodeId));
};
